import configManager from "../../../singleton/ConfigManager";

export const addSetsToBindings = mapping => {
  for (const setName in mapping) {
    const filteredBindings = mapping[setName].filter(binding => (!binding?.validateShortcut || (binding?.validateShortcut && configManager.config.shortcuts.enabled)))
    mapping[setName] = filteredBindings; // Update the mapping with filtered bindings
    for (const binding of mapping[setName]) {
      if (!binding.sets) {
        binding.sets = [];
      }
      binding.sets.push(setName);
    }
  }
  return mapping;
};
